import { configureStore } from '@reduxjs/toolkit'

import { configReducer } from './configuration'
import { authReducer } from './authentication'
import { ferryContentReducer } from './ferryContent'
import { itinerariesReducer } from './itineraries'
import { accommodationContentReducer } from './accommodationContent'
import { userVehiclesReducer } from './userVehicles'

export const store = configureStore({
  reducer: {
    accommodationContent: accommodationContentReducer,
    configuration: configReducer,
    ferryContent: ferryContentReducer,
    itineraries: itinerariesReducer,
    userData: authReducer,
    userVehicles: userVehiclesReducer,
  },
})
